import type { getJob } from '~/models/job.server'
import { ATS } from '@prisma/client'
import { ApplicationForm as Workable } from './ApplicationForm.WORKABLE'
import { ApplicationForm as JazzHR } from './ApplicationForm.JAZZHR'
import { ApplicationForm as Lever } from './ApplicationForm.LEVER'
import { ApplicationForm as Greenhouse } from './ApplicationForm.GREENHOUSE'
import { ErrorsList } from '~/types'

export const ApplicationForm = ({
  job,
  errors,
}: {
  job: Awaited<ReturnType<typeof getJob>>
  errors: ErrorsList
}) => {
  if (job?.ats === ATS.WORKABLE) {
    return <Workable job={job} errors={errors} />
  }

  if (job?.ats === ATS.JAZZHR) {
    return <JazzHR job={job} errors={errors} />
  }

  if (job?.ats === ATS.LEVER) {
    return <Lever job={job} errors={errors} />
  }

  if (job?.ats === ATS.GREENHOUSE) {
    return <Greenhouse job={job} errors={errors} />
  }

  return null
}
